import * as React from "react";
import { useEffect, useState } from "react";
import {
  Avatar,
  Navbar,
  NavbarContent,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tab,
  Tabs,
  Tooltip,
} from "@heroui/react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { UserCard } from "./UserCard";
import { useTranslation } from "react-i18next";

export const NavigationTabs: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>("mistakes");
  const { t } = useTranslation();

  useEffect(() => {
    switch (activeTab) {
      case "mistakes":
        navigate("/");
        break;
      case "vocabulary":
        navigate("/vocabulary");
        break;
      case "dictionary":
        navigate("/dictionary");
        break;
      default:
        navigate("/");
    }
  }, [navigate, activeTab]);

  return (
    <Navbar className="mb-2 rounded-[15px]">
      <NavbarContent className="gap-1" justify="start" />
      <NavbarContent justify="center">
        <Tabs
          defaultSelectedKey="mistakes"
          aria-label="Options"
          variant="bordered"
          onSelectionChange={(key) => setActiveTab(key.toString())}
          selectedKey={activeTab}
        >
          <Tab
            key="mistakes"
            title={
              <div className="flex items-center space-x-2">
                <Tooltip content="Алдаа шалгуур" placement="bottom">
                  <img src="/assets/logo1.png" alt="Spell Check" width={20} height={20} />
                </Tooltip>
                <span className="md:block hidden">{t("spellCheck")}</span>
              </div>
            }
          />
          <Tab
            key="vocabulary"
            title={
              <div className="flex items-center space-x-2">
                <Tooltip content="Үгсийн сан" placement="bottom">
                  <img src="/assets/logo3.png" alt="Vocabulary" width={20} height={20} />
                </Tooltip>
                <span className="md:block hidden">{t("vocabulary")}</span>
              </div>
            }
          />
          <Tab
            key="dictionary"
            title={
              <div className="flex items-center space-x-2">
                <Tooltip content="Болор толь" placement="bottom">
                  <img src="/assets/logo2.png" alt="Dictionary" width={20} height={20} />
                </Tooltip>
                <span className="md:block hidden">{t("dictionary")}</span>
              </div>
            }
          />
        </Tabs>
      </NavbarContent>
      <NavbarContent className="gap-1" justify="end">
        <Popover showArrow placement="bottom">
          <PopoverTrigger>
            <Avatar
              className="w-[30px] h-[30px]"
              fallback={<Icon width={20} height={20} icon="clarity:avatar-line" />}
              isBordered
              name="User"
            />
          </PopoverTrigger>
          <PopoverContent className="p-1">
            <UserCard />
          </PopoverContent>
        </Popover>
      </NavbarContent>
    </Navbar>
  );
};
